import React, {useEffect, useState} from "react";
import Matches from "../FixturesComponents/Matches";
import EditPreGameSelections from "../../../assets/images/eoro-2024/edit-pregame-selections.svg";
import PredictScoreModal from "../FixturesComponents/PredictScoreModal";
import {GET_LEAGUE_MATCH_DAY_FIXTURES, STAGING_BASE_URL} from "../../../Axios/EndPoints";
import {get} from "../../../Axios/get";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";

const Fixtures = (props) => {
    const {
        isMobile,
        leagueMatchDays,
        leagueId,
        currentMatchDay,
        setCurrentMatchDay,
        // deadlineReached,
    } = props;

    // console.log("currentMatchDay >>>", currentMatchDay)
    // const { id } = useParams();

    const { id } = useParams();

    // console.log("tab is >>>", tab, " and id is >>>>", id)
    const navigate = useNavigate();

    const [params] = useSearchParams();
    const user = useSelector(state => state?.Login);

    // console.log("leagueMatchDays on fixtures>>>", leagueMatchDays)

    const [loading, setLoading] = useState(false);
    const [matches, setMatches] = useState([]);
    // console.log("matches >>>", matches)

    const initialActiveMatchDay = leagueMatchDays?.find(matchDay => matchDay?.is_active);
    // console.log("initialActiveMatchDay >>>", initialActiveMatchDay)
    const [selectedMatchDay, setSelectedMatchDay] = useState(id || initialActiveMatchDay?.id);

    // console.log("selectedMatchDay>>>>", selectedMatchDay)

    // const [selectedMatchDay, setSelectedMatchDay] = useState(leagueMatchDays[0]?.id);
    const [predictScore, setPredictScore] = useState(false);
    // console.log("predictScore >>>", predictScore)

    // const [currentMatchDay, setCurrentMatchDay] = useState(leagueMatchDays[0]);

    useEffect(() => {
        const activeMatchDay = leagueMatchDays?.find(matchDay => matchDay?.is_active);
        setCurrentMatchDay(activeMatchDay);
    }, [leagueMatchDays]);

    const fetchMatches = () => {
        let isStaging = parseInt(params.get('staging'));
        setLoading(true);
        let endpoint = GET_LEAGUE_MATCH_DAY_FIXTURES;
        endpoint = endpoint.replace('__MATCH_DAY_ID__', selectedMatchDay);
        get(
            endpoint,
            true,
            user?.token,
            null,
            isStaging ? STAGING_BASE_URL : ''
        ).then(res => {
            // console.log("reposne for getting match day fixtures >>>", res?.data?.data)
            setMatches(res?.data?.data?.matches);
        }).catch(error => {
            console.error("Error while getting match day fixtures : ", error);
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(() => {
        fetchMatches();
    }, [selectedMatchDay]);

    const onClickMatchDay = (matchDayId, matchDay) => {
        setSelectedMatchDay(matchDayId);
        setCurrentMatchDay(matchDay);
        navigate(`/euro-24/fixtures/${matchDayId}`);
    };

    const renderMobile = () => {
        return (
            <>
                <div className={"d-flex flex-row align-items-center justify-content-between px-3 gap-2"}>
                    {leagueMatchDays?.map((matchDay, index) => (
                        <div
                            key={index}
                            role={"button"}
                            className={`px-3 py-1 w-fit rounded fw-300 font-14 cabin text-center ${
                                ((selectedMatchDay === matchDay?.id) || (matchDay?.id === parseInt(id))) ? 'bg-green text-white ' : 'bg-white'
                            }`}
                            onClick={(e) => {
                                e.preventDefault();
                                onClickMatchDay(matchDay?.id, matchDay);
                            }}
                        >
                            {matchDay?.name}
                        </div>
                    ))}
                </div>
                {
                    matches?.length > 0 ?
                        <>
                            {
                                currentMatchDay?.prediction_allowed &&
                                <>
                                    <div className={"mt-3 d-flex align-items-center justify-content-end"}>

                                        <div
                                            role={"button"}
                                            className={"d-flex align-items-center justify-content-end gap-2 me-2"}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                // setEdit(true);
                                                setPredictScore(true);
                                                // console.log("Trigger Predict Score Modal")
                                            }}
                                        >
                                            <div className={"text-skins-teal fw-700 cabin font-16 text-nowrap"}>Predict Scores</div>
                                            <img
                                                src={EditPreGameSelections}
                                                className=""
                                                alt={"edit"}
                                                height={25}
                                                width={25}
                                            />
                                        </div>
                                    </div>
                                </>
                            }

                            <div className={`px-3 ${currentMatchDay?.prediction_allowed ? "mt-1" : "mt-3"}`}>
                                <Matches
                                    matchDayId={selectedMatchDay}
                                    isMobile={isMobile}
                                    loading={loading}
                                    matches={matches}
                                    fetchMatches={fetchMatches}
                                    leagueId={leagueId}
                                    isPredictionAllowed={currentMatchDay?.prediction_allowed}
                                />
                            </div>
                        </>
                        :
                        <>
                            <div className={"pt-5 pb-4 text-skins-red text-center fw-800 font-40 bebas"}>
                                To be updated soon
                            </div>
                        </>
                }

            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                <div className={"d-flex flex-row align-items-center justify-content-between gap-3"}>
                    {leagueMatchDays?.map((matchDay, index) => (
                        <div
                            key={index}
                            role={"button"}
                            className={`px-5 py-2 w-fit rounded fw-500 font-25 cabin ${
                                ((selectedMatchDay === matchDay?.id) || (matchDay?.id === parseInt(id))) ? 'bg-green text-white' : 'bg-white'
                            }`}
                            onClick={(e) => {
                                e.preventDefault();
                                onClickMatchDay(matchDay?.id, matchDay);
                            }}
                        >
                            <div className={"mx-5"}>
                                {matchDay?.name}
                            </div>
                        </div>
                    ))}

                </div>
                {
                    matches?.length > 0 ?
                        <>
                            {
                                currentMatchDay?.prediction_allowed &&
                                <>
                                    <div className={"mt-3 d-flex align-items-center justify-content-center"}>
                                        <div
                                            role={"button"}
                                            className={"d-flex align-items-center justify-content-end gap-2"}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                // setEdit(true);
                                                setPredictScore(true);
                                                // console.log("Trigger Predict Score Modal")
                                            }}
                                        >
                                            <div className={"text-skins-teal fw-700 cabin font-30"}>Predict Scores</div>
                                            <img
                                                src={EditPreGameSelections}
                                                className=""
                                                alt={"edit"}
                                                height={40}
                                                width={30}
                                            />
                                        </div>
                                    </div>
                                </>
                            }


                            <div className={`${currentMatchDay?.prediction_allowed ? "" : "mt-3"}`}>
                                <Matches
                                    matchDayId={selectedMatchDay}
                                    isMobile={isMobile}
                                    loading={loading}
                                    matches={matches}
                                    fetchMatches={fetchMatches}
                                    leagueId={leagueId}
                                    isPredictionAllowed={currentMatchDay?.prediction_allowed}
                                />
                            </div>
                        </>:
                        <>
                            <div className={"pt-5 pb-4 text-skins-red text-center fw-800 font-40 bebas"}>
                                To be updated soon
                            </div>
                        </>
                }

            </>
        );
    }
    const render = () => {
        return (
            <section>
                {isMobile ? renderMobile() : renderDesktop()}
                {
                    predictScore &&
                    <PredictScoreModal
                        showModal={predictScore}
                        setShowModal={setPredictScore}
                        matches={matches}
                        selectedMatchDay={selectedMatchDay}
                        leagueId={leagueId}
                        fetchMatches={fetchMatches}
                    />
                }
            </section>
        );
    }

    return render();
}

export default Fixtures;
